import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { Box, Button, Card, CardBody, CardHeader, Flex, FormControl, FormLabel, Heading, Input, VStack } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { useAppContext } from 'hooks/useAppContext'
import { getBackWrapPricingConfig, getSideVentPricingConfig, setBackWrapPricingConfig, setSideVentPricingConfig } from 'api'

const BreadcrumbNav = [
  {
    label: 'Back Wrap & Side Vent Pricing',
    isCurrentPage: true
  }
]

export const BackWrapSideVentPricingForm = () => {
  const { createToast } = useAppContext()
  const [form, setForm] = useImmer({
    backWrapBase: 0,
    backWrapPerSqft: 0,
    sideVentBase: 0,
    sideVentPerFoot: 0
  })
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const [backWrapConfig, sideVentConfig] = await Promise.all([
          getBackWrapPricingConfig(),
          getSideVentPricingConfig()
        ])
        setForm(draft => {
          draft.backWrapBase = backWrapConfig.backWrapBase
          draft.backWrapPerSqft = backWrapConfig.backWrapPerSqft
          draft.sideVentBase = sideVentConfig.sideVentBase
          draft.sideVentPerFoot = sideVentConfig.sideVentPerFoot
        })
      } catch (err) {
        createToast('error', 'Error', err.response.data)
      }
    }
    load()
  }, [])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSaving(true)
    try {
      const [backWrapConfig, sideVentConfig] = await Promise.all([
        setBackWrapPricingConfig({
          backWrapBase: form.backWrapBase,
          backWrapPerSqft: form.backWrapPerSqft
        }),
        setSideVentPricingConfig({
          sideVentBase: form.sideVentBase,
          sideVentPerFoot: form.sideVentPerFoot
        })
      ])
      setForm(draft => {
        draft.backWrapBase = backWrapConfig.backWrapBase
        draft.backWrapPerSqft = backWrapConfig.backWrapPerSqft
        draft.sideVentBase = sideVentConfig.sideVentBase
        draft.sideVentPerFoot = sideVentConfig.sideVentPerFoot
      })
      createToast('success', 'Successfully updated.')
      setIsSaving(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSaving(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Back Wrap & Side Vent Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Configuration</Heading>
          </CardHeader>
          <CardBody p={8}>
            <form onSubmit={handleSubmit}>
              <VStack gap={2} maxW="500px">
                <FormControl isRequired>
                  <FormLabel>Back Wrap Base Price</FormLabel>
                  <Input type="number" name="backWrapBase" value={form.backWrapBase} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Back Wrap Price Per Sqft</FormLabel>
                  <Input type="number" name="backWrapPerSqft" value={form.backWrapPerSqft} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Side Vent Base Price</FormLabel>
                  <Input type="number" name="sideVentBase" value={form.sideVentBase} onChange={handleChange} />
                </FormControl>
                <FormControl isRequired>
                  <FormLabel>Side Vent Price Per Foot</FormLabel>
                  <Input type="number" name="sideVentPerFoot" value={form.sideVentPerFoot} onChange={handleChange} />
                </FormControl>
              </VStack>
              <Button type="submit" mt={8} colorScheme="blue" isLoading={isSaving}>Save</Button>
            </form>
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
